import React, { Component } from 'react'
import axios from 'axios';

export default class requests extends Component {

    componentDidMount(){

        
        
        axios.post( `${process.env.REACT_APP_API_ENDPOINT}/account/update-profile`)
        .then((res) => {
            console.log("RESPONSE RECEIVED: ", res);

        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        }) 

        
    }
    render() {
        return (
            <div>
              <form onSubmit={this.handleSubmit}>
                  <input type="text" />
                  <input type="Submit" value="Test Request" />
                  <p> lorem </p>
              </form>  
            </div>
        )
    }
}
